(function($) {

	$(document.body).click(function() {
		$(".c-sizer__content.open").removeClass("open");
		$(".c-product-hero__card__inner").css("overflow","hidden");
	});

	$("main.c-category__main").on("click", ".c-sizer__click", function(e) {
		$(this).next().toggleClass("open");
		e.stopPropagation();
	});

	$(".c-sizer").on("click", ".c-sizer__click", function(e) {
		$(this).next().toggleClass("open");
		$(".c-product-hero__card__inner").css("overflow","inherit");
		e.stopPropagation();

	});

	$(document.body).keyup(function(e) {
		if (e.key === 'Escape') {
			$(".c-sizer__content.open").removeClass("open");
		}
	});


})(jQuery);
